export default (recipts) => { 
  const state = { 
    search: {
      terms: [],
      tags: []
    },
    recipts
  }
  
  const getters = {
      getRandomByTag: state => tag => {
          const arr = state.recipts.filter(item => item.tags.indexOf(tag) >= 0)
          const index = Math.floor(Math.random()*arr.length)
          return arr[index]
      },
      getBySearch: state => { 
        if (state.search.terms.length === 0 && state.search.tags.length === 0) return []
        else {
          return state.recipts.filter(item => {
            return (state.search.terms.length === 0 || undefined !== item.preparation.find(line => {
                return undefined !== state.search.terms.find(term => line.toLowerCase().indexOf(term.toLowerCase()) >= 0 )
            }) || undefined !== state.search.terms.find(term => item.name.toLowerCase().indexOf(term.toLowerCase()) >= 0 ))
            && (state.search.tags.length === 0 || item.tags.find(tag => state.search.tags.find(i => i === tag)))
          })
        }
      },
      getSearch: state => state.search
  }
  const mutations = {
    setSearchTerm (state, line) {
      if (typeof line === 'string') {
        state.search.terms = line.split(' ')
          .map(term => term.replace(',', '').trim().toLowerCase())
          .filter(term => term.length > 0)
      }
    },
    setSearchTags (state, tags) {
      if (tags instanceof Array) {
        state.search.tags = tags
      }
    }
  }

  return {
    state,
    getters,
    mutations
  }
}


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/recipts.js